"use strict";
/**
 * Shared API contract types and Zod schemas.
 * Keep request payloads aligned across web, mobile, and backend.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionCancelSchema = exports.subscriptionCreateSchema = exports.guestInviteSchema = exports.meetupUpdateSchema = exports.meetupCreateSchema = exports.groupPayloadSchema = exports.profileUpdateSchema = void 0;
const zod_1 = require("zod");
exports.profileUpdateSchema = zod_1.z
    .object({
    name: zod_1.z.string().min(1).max(200).optional(),
    bio: zod_1.z.string().max(2000).optional(),
    avatar_url: zod_1.z.string().url().optional().or(zod_1.z.literal('')),
    location: zod_1.z.string().max(500).optional(),
    latitude: zod_1.z.number().min(-90).max(90).optional(),
    longitude: zod_1.z.number().min(-180).max(180).optional(),
    interests: zod_1.z.array(zod_1.z.string()).optional(),
    preferences: zod_1.z.record(zod_1.z.unknown()).optional(),
})
    .passthrough();
exports.groupPayloadSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(200),
    description: zod_1.z.string().max(2000).optional(),
    privacy: zod_1.z.enum(['public', 'private']).optional(),
    avatar_url: zod_1.z.string().url().optional().or(zod_1.z.literal('')),
});
exports.meetupCreateSchema = zod_1.z.object({
    title: zod_1.z.string().min(1).max(200),
    description: zod_1.z.string().max(5000).optional(),
    scheduled_at: zod_1.z.string().datetime().optional(),
    location_name: zod_1.z.string().max(500).optional(),
    latitude: zod_1.z.number().min(-90).max(90).optional(),
    longitude: zod_1.z.number().min(-180).max(180).optional(),
    max_participants: zod_1.z.number().int().positive().optional(),
    category: zod_1.z.string().max(100).optional(),
    is_private: zod_1.z.boolean().optional(),
});
exports.meetupUpdateSchema = exports.meetupCreateSchema.partial();
exports.guestInviteSchema = zod_1.z.object({
    meetupId: zod_1.z.union([zod_1.z.string().uuid(), zod_1.z.number().int().positive()]),
    emails: zod_1.z.array(zod_1.z.string().email()).min(1).max(50).optional(),
    guests: zod_1.z
        .array(zod_1.z.object({
        email: zod_1.z.string().email(),
        name: zod_1.z.string().max(200).optional(),
    }))
        .optional(),
    message: zod_1.z.string().max(2000).optional(),
});
exports.subscriptionCreateSchema = zod_1.z.object({
    planId: zod_1.z.string().uuid(),
    paymentMethodId: zod_1.z.string().optional(),
    billingCycle: zod_1.z.enum(['monthly', 'annual']).default('monthly'),
});
exports.subscriptionCancelSchema = zod_1.z.object({
    reason: zod_1.z.string().max(1000).optional(),
    feedback: zod_1.z.string().max(5000).optional(),
});
